import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { createRef, useEffect, useRef, useState } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import Button from "../../shared/button/Btn";
import SmallSpinner from "../../shared/spinners/SmallSpinner";
import { showRegisterModal } from "../../../features/register/registerSlice";
import { forgotVerificationCheck, sendMailAdresForVerificationForgot } from "../../../features/auth/authSlice";


const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 500px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 30px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    justify-content: space-between;

    .content{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      p{
          font-size: 22px;
          font-weight: var(--font-weight-lg);
      }

      .verification-container{
          display: flex;
          align-items: center;
          gap: 10px;
          margin-block: 40px;
          input{
              border-bottom: 1px solid black;
              padding: 5px ;
              width: 40px;
              text-align: center;
              font-size: 30px;
              font-weight: var(--font-weight-lg);
          }
      }

        .time{
          font-size: 1.4rem;
          font-weight: var(--font-weight-lg);
          color: var(--color-main);
          padding: 10px 0;
          text-align: center;
        }

        .time-desc{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          color: var(--color-main);
          padding:  15px 0;
          text-align: center;
        }

        .btn-container{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
        }
    }
  }
  .resend{
    margin-block: 20px;
    cursor: pointer;
    color: var(--color-main);
    text-decoration: underline;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      font-size: 14px;
    }
  }
  .error{
    color: var(--color-main);
    font-size: var(--font-size-sm);
  }
`;

const ForgotVerificationCodeModal = () => {
  const dispatch = useDispatch()
  const {forgotData, isLoadingSendVerification} = useSelector(state => state.auth)
  const { message, forgotPasswordVerificationCodeTimer, forgotPasswordVerificationStatus, isLoadingSendMail } = useSelector((state) => state.auth);

  
  const [verificationNumbers, setVerificationNumbers] = useState({
    num1: "",
    num2: "",
    num3: "",
    num4: "",
    num5: "",
    num6: "",
  })
  
  const { lockScroll, unlockScroll } = useScrollLock();
  const inputs = useRef([]);

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  const handlePaste = (e) => {
    const pasteData = e.clipboardData.getData("text").replace(/\D/g, ""); // Sadece sayıları al
    const newValues = { ...verificationNumbers };
    pasteData.split("").forEach((char, index) => {
      if (index < 6) {
        newValues[`num${index + 1}`] = char;
      }
    });
    setVerificationNumbers(newValues);
    inputs.current[5].focus(); // Son inputa odaklan
  };

  const handleChange = (index, e) => {
    const value = e.target.value.replace(/\D/g, ""); // Sadece sayıları al
    const newValues = { ...verificationNumbers };
    newValues[`num${index + 1}`] = value.slice(-1); // Sadece son karakteri al
    setVerificationNumbers(newValues);
    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !verificationNumbers[`num${index + 1}`]) {
      inputs.current[index - 1].focus();
    }
  };

    const handleSubmit = () => {
        const verificationCode = Object.values(verificationNumbers).join('');
        dispatch(forgotVerificationCheck({email: forgotData?.email, code: verificationCode}))
    }

    const resend = () => {
      dispatch(sendMailAdresForVerificationForgot({email: forgotData.email}))
      setVerificationNumbers({
        num1: "",
        num2: "",
        num3: "",
        num4: "",
        num5: "",
        num6: "",
      })
    }

  return (
    <Container>
      <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)); }}>
        <div className="content">
            <p>Mailinize Gelen Doğrulama Kodu</p>

            <div className="verification-container">
             {Object.keys(verificationNumbers).map((key, index) => (
                <input
                  key={key}
                  type="text"
                  name={key}
                  onPaste={handlePaste}
                  value={verificationNumbers[key]}
                  onChange={(e) => handleChange(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  ref={(el) => (inputs.current[index] = el)}
                  maxLength={1}
                  pattern="\d*" // Sadece sayı girişine izin verir
                  inputMode="numeric" // Mobil cihazlarda sadece sayı klavyesini açar
                />
              ))}
            </div>
            {
              forgotPasswordVerificationCodeTimer >= 1 ?
              <div className="time">{forgotPasswordVerificationCodeTimer} Saniye</div>
              :
              <div className="time-desc">Süreniz doldu. Tekrar kod gönderebilirsiniz.</div>
            }
            {message && <div className="error">{message}</div> }
            <div className="resend">
              <span onClick={resend}>{isLoadingSendMail ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Tekrar kod gönder."}</span>
            </div>
            {
              ((verificationNumbers.num1 && verificationNumbers.num2 && verificationNumbers.num3 && verificationNumbers.num4 && verificationNumbers.num5 && verificationNumbers.num6) && forgotPasswordVerificationCodeTimer >= 1) &&
              <div className="btn-container">
                <Button handleClick={() => handleSubmit()} color="#E85446" bgColor="transparent" padding="0px 10px" width="150px">{isLoadingSendVerification ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Gönder"}</Button>
              </div>
            }
              <Button handleClick={() => dispatch(showRegisterModal(null))} color="#E85446" bgColor="transparent" padding="0px 10px" width="150px">Kapat</Button>
        </div>
      </div>
    </Container>
  );
};

export default ForgotVerificationCodeModal;
